// Dependencies
import { h, Component, Fragment } from 'preact';
import {connect} from 'react-redux'

// Components
import {Form, I18n, Button, Col, Row, Container} from 'components/elements'
import WidgetComponent from 'components/WidgetComponent'

// Actions
import {
    AccountActions,
    PageActions,
    SessionActions
} from 'actions'

// Helpers
import { formatPhoneNumber } from 'lib/helpers';

// Styles
import style from './index.less'

// Icons
import chevronLeft from '../../../assets/icons/svg/chevron_left.svg'
import chevronRight from '../../../assets/icons/svg/chevron_right.svg'

// Component Class
@Form
@connect((state)=> state)
export default class ResetPrompt extends WidgetComponent {

    // Constructor
    constructor(props, context){
        super(props, context)
        this.state = {
            passwordError: false,
            resetError: false,
            resetSent: false,
            value: ''
        }

        this.handleBackToLogin = this.handleBackToLogin.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleResetPassword = this.handleResetPassword.bind(this)
    }

    // Methods
    handleResetPassword(){
        let optional = {}
        if(this.props.config.type){
            optional.type=this.props.config.type
        }
        AccountActions.resetPassword({
            authenticators: {
                email: this.props.session.account.email,
                mobilePhone: this.props.session.account.mobilePhone
            }, 
            url: location.protocol + '//' + location.host + location.pathname, 
            organizationID: this.props.organization.id,
            ...optional
        }).then((response)=>{
            this.setState({
                resetSent: true
            })
        }).catch((e)=>{
            this.setState({
                resetError: true
            })
        })
    }

    handleChange(e){
        if(this.state.passwordError){
            this.setState({
                passwordError: false
            })
        }
        if(e.target.name == 'value'){
            this.setState({
                value: e.target.value,
                resetError: false
            })
        }
    }

    handleBackToLogin(e){
        SessionActions.setAuthenticationMode('login')
        PageActions.navToLogin()
    }

    // Getters
    get validAuthenticators(){
        const authenticators = {}
        if(this.props.session.account.email){
            authenticators.email = this.props.session.account.email
        }
        if(this.props.session.account.mobilePhone){
            authenticators.mobilePhone = this.props.session.account.mobilePhone
        }

        return authenticators;
    }
    get isEmailValid(){
        return !!this.props.session.account.email
    }

    // Render Method
    render(){
        const {InputDark, Form} = this.props
        return (
            <Form class={style.login} onSubmit={this.handleResetPassword}>
                <Container class={`${this.props.class || ""} ${style.containerView}`}>
                    <Row>
                        <Col span={{sm:24}} class={style.noPadding}>     
                            {!this.state.resetSent &&  <Fragment>
                                    <div className={style.title}>
                                        <I18n>pleaseConfirmYourContactInformation</I18n>
                                    </div>
                                    <div className={style.userInfo} style={{padding: "10px 0px 40px 20px"}}>
                                        {this.props.session.account.email && 
                                            <div className={style.userInfoItem}>
                                                <span><I18n>email</I18n>: </span>
                                                {this.props.session.account.email}
                                            </div>
                                        }
                                        {this.props.session.account.mobilePhone && 
                                            <div className={style.userInfoItem}>
                                                <span><I18n>mobilePhone</I18n>: </span>
                                                {formatPhoneNumber(this.props.session.account.mobilePhone)}
                                            </div>
                                        }
                                    </div>
                                </Fragment>
                            }
                            <div class={style.errorSpacing}>
                                    {this.state.resetError && 
                                        <div class={style.errorMessage}>
                                            {this.props.session.authenticationMode == 'claim' && (
                                               <I18n>errorClaimingAccount</I18n>
                                            )}
                                            {this.props.session.authenticationMode == 'reset' && (
                                                 <I18n>errorResettingPassword</I18n>
                                            )}
                                            </div>
                                    }
                            </div>
                            {this.state.resetSent  && (
                                <div class={style.resetSent}>
                                    <div class={style.resetSentTitle}>
                                        <I18n>checkYourInbox</I18n>
                                    </div>
                                    <div class={style.resetSentDescription}>
                                        {this.props.session.authenticationMode == 'claim' && (
                                            <I18n>resentMessageForClaimAccount</I18n>
                                        )}
                                        {this.props.session.authenticationMode == 'reset' && (
                                            <I18n>resentMessageForPasswordReset</I18n>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row class={style.actionsButtons}>
                        <Col class={style.containerBtns}>
                            <Button type={"button"} theme={"gray"} onClick={this.handleBackToLogin} class={style.returnBtn}>
                                {!this.state.resetSent && <img src={chevronLeft} alt="Edit Icon"/>}
                                <span>
                                    <I18n>{this.state.resetSent ? "backToLogin":"back" }</I18n>
                                </span>
                            </Button>
                            {!this.state.resetSent &&
                                <Button class={style.returnBtn}>
                                    <span>
                                        <I18n>send</I18n>
                                    </span>
                                    <img src={chevronRight} alt="Send Icon"/>
                                </Button>
                            }
                        </Col>
                    </Row>
                </Container>
            </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./components/partials/ResetPasswordPrompt/index.js